import { findMatchGroups } from "./match.js";

/**
 * Returns true if there's at least one adjacent swap that would create a match.
 * This prevents "dead boards" where the player can't move.
 */
export function hasPossibleMoves(grid) {
  const rows = grid.length;
  const cols = grid[0].length;

  const swap = (r1, c1, r2, c2) => {
    const t = grid[r1][c1];
    grid[r1][c1] = grid[r2][c2];
    grid[r2][c2] = t;
  };

  // Only need to test right and down swaps to cover all adjacencies
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const dirs = [[1, 0], [0, 1]];
      for (const [dr, dc] of dirs) {
        const r2 = r + dr;
        const c2 = c + dc;
        if (r2 >= rows || c2 >= cols) continue;

        swap(r, c, r2, c2);
        const { all } = findMatchGroups(grid);
        swap(r, c, r2, c2);

        if (all.length > 0) return true;
      }
    }
  }
  return false;
}

/**
 * Shuffles only the COLORS of tiles (keeps sprites/positions), then refreshes sprite fills.
 * Also tries a few times to avoid immediate matches AND ensure at least one possible move.
 */
export function shuffleBoard(board, maxTries = 25) {
  const colors = [];
  for (let r = 0; r < board.rows; r++) {
    for (let c = 0; c < board.cols; c++) {
      colors.push(board.grid[r][c].color);
    }
  }

  for (let attempt = 0; attempt < maxTries; attempt++) {
    fisherYates(colors);

    // apply colors
    let i = 0;
    for (let r = 0; r < board.rows; r++) {
      for (let c = 0; c < board.cols; c++) {
        const t = board.grid[r][c];
        t.color = colors[i++];
        t.sprite.fillColor = colorToHex(t.color);
      }
    }

    // avoid immediate matches & ensure at least one move
    const { all } = findMatchGroups(board.grid);
    if (all.length === 0 && hasPossibleMoves(board.grid)) return true;
  }

  return false;
}

function fisherYates(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = (Math.random() * (i + 1)) | 0;
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}

function colorToHex(color) {
  switch (color) {
    case "red": return 0xef4444;
    case "yellow": return 0xf59e0b;
    case "green": return 0x22c55e;
    case "blue": return 0x3b82f6;
    case "purple": return 0xa855f7;
    default: return 0xffffff;
  }
}
